import toastr from 'toastr';
import postal from 'postal';
import parseFailXhr from '../../shared/parse-fail-xhr';
import { markRead, markUnread } from '../../services/notifications-service';

function errorHandler(message) {
  return e => {
    const errors = parseFailXhr(e.jqXHR);

    if (errors.anyUnhandledErrors()) {
      toastr.error(errors.getErrorSummary(), message);
    }
  };
}

const p = postal.channel('notifications.commands');

export default function Notification(notification) {
  Object.assign(this, notification);
}

Notification.prototype.isRead = function isRead() {
  return !!this.read_at;
};

Notification.prototype.open = function open() {
  const wasRead = this.isRead();
  markRead(this.id)
    .then(() => {
      this.read_at = 'read';
      p.publish('read-status', { id: this.id, isRead: true });
      wasRead || p.publish('decrement-unread-count');
      if (this.notification_url) {
        window.location = this.notification_url;
      } else {
        toastr.error('Cannot open notification');
      }
    })
    .catch(errorHandler('Error marking notification as read'));
};

Notification.prototype.toggleReadStatus = function toggleReadStatus() {
  const wasRead = this.isRead();
  const action = wasRead ? markUnread : markRead;

  action(this.id)
    .then(() => {
      this.read_at = wasRead ? null : 'read';
      const payload = {
        id: this.id,
        isRead: !wasRead,
      };
      p.publish('read-status', payload);
      p.publish(wasRead ? 'increment-unread-count' : 'decrement-unread-count');
    })
    .catch(errorHandler('Error toggling read state for notification'));
};
